export default __webpack_public_path__ + "static/media/6.287d8415.JPG";